import React from 'react';
import { connect } from 'react-redux';
import {
  GeckoForm,
  GeckoFormField,
  GeckoModal,
  GeckoToastService,
  GeckoModalService,
  GECKO_CONSTS,
} from 'ui';
import GeckoRequest from '../../../services/gecko-request';
import GeckoLocation from '../../../services/gecko-location';
import {
  updateIntegration,
  newIntegration,
} from '../../../actions/integrations';
import './WebhookEditModal.scss';

const AUTH_ERROR = 'Auth key and auth value must be supplied as a pair';
const hasOnlyAuthKey = (authKey, authValue) => authKey && !authValue;
const hasOnlyAuthValue = (authKey, authValue) => !authKey && authValue;

const validate = ({ url, authKey, authValue }) => {
  const errors = {};
  if (!url) {
    errors.url = 'Webhooks require a URL';
  }
  if (hasOnlyAuthValue(authKey, authValue)) {
    errors.authKey = AUTH_ERROR;
  }
  if (hasOnlyAuthKey(authKey, authValue)) {
    errors.authValue = AUTH_ERROR;
  }
  return errors;
};

const WebhookEditModal = ({
  newIntegration,
  updateIntegration,
  configuration = {},
  id,
  currentUser,
}) => {
  const newWebhook = (account_id, url, authKey, authValue) => ({
    account_id,
    configuration: { url, authKey, authValue },
    type: 'webhook',
    id: id,
  });

  const submit = ({ url, authKey, authValue }) => {
    const webhookConfig = newWebhook(
      currentUser.account_id,
      url,
      authKey,
      authValue
    );
    const isNewWebhook = webhookConfig.id === undefined;
    GeckoRequest.post('/integration/webhook', webhookConfig).then(
      (integration) => {
        isNewWebhook
          ? newIntegration(integration)
          : updateIntegration(integration);

        new GeckoToastService().success('Integration added');
        new GeckoModalService().close();
        GeckoLocation.reload();
      }
    );
  };

  const initialValues = {
    url: configuration.url ? configuration.url : '',
    authKey: configuration.authKey ? configuration.authKey : '',
    authValue: configuration.authValue ? configuration.authValue : '',
  };

  return (
    <GeckoForm
      initialValues={initialValues}
      onSubmit={submit}
      validate={validate}
    >
      {({ hasTriedToSubmit, values, handleSubmit, errors }) => (
        <GeckoModal
          name="Please enter your Webhook details:"
          btns={[
            {
              type: GECKO_CONSTS.BTN_TYPE_PRIMARY,
              name: 'Done',
              icon: 'far fa-check',
              handler: handleSubmit,
            },
          ]}
        >
          <div className="WebhookForm">
            <GeckoFormField
              fieldType="text"
              name="url"
              label="Url"
              placeholder="Enter a Url"
              required
            />
            <GeckoFormField
              fieldType="text"
              name="authKey"
              label="Auth Key"
              placeholder="Enter an Auth Key"
              error={
                hasTriedToSubmit &&
                hasOnlyAuthValue(values.authKey, values.authValue)
                  ? AUTH_ERROR
                  : undefined
              }
            />
            <GeckoFormField
              fieldType="text"
              name="authValue"
              label="Auth Value"
              placeholder="Enter an Auth Value"
              error={
                hasTriedToSubmit &&
                hasOnlyAuthKey(values.authKey, values.authValue)
                  ? AUTH_ERROR
                  : undefined
              }
            />
          </div>
        </GeckoModal>
      )}
    </GeckoForm>
  );
};

const mapStateToProps = (state) => {
  const webhook = state.integrations.find(
    (integration) => integration.type === 'webhook'
  );

  return {
    configuration: webhook?.configuration,
    id: webhook?.id,
    currentUser: state.appState.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateIntegration: (integration) => {
      dispatch(updateIntegration(integration));
    },
    newIntegration: (integration) => {
      dispatch(newIntegration(integration));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WebhookEditModal);
